import React from 'react';

function ShareIcon(props) {
    return (
        <svg width="16px" height="19px" fill="none" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3 6a3 3 0 100-6 3 3 0 000 6zm10 6.5a3 3 0 100-6 3 3 0 000 6zM3 19a3 3 0 100-6 3 3 0 000 6z"
                fill="#1D1D1D"
            />
            <rect width={14} height={2} rx={1} transform="scale(1 -1) rotate(33 31.176 -4.3)" fill="#1D1D1D" />
            <rect x={3.526} y={2.621} width={13} height={2} rx={1} transform="rotate(33 3.526 2.621)" fill="#1D1D1D" />
        </svg>
    );
}

export default ShareIcon;
